import type { PostFormRedirectParams } from '../types'

const createHiddenInput = (key: string, value: string): HTMLInputElement => {
  const hiddenInput = document.createElement('input')
  hiddenInput.type = 'hidden'
  hiddenInput.name = key
  hiddenInput.value = value

  return hiddenInput
}

/**
 * The parameters that postFormRedirect expects
 */

/**
 * A function to programmatically create a hidden form and submit it, resulting in a browser redirect & server roundtrip
 * emulating how an actual form post with a redirect would behave
 * @throws Will throw an error if the authenticity token is empty
 * @throws Will throw an error if the URL is empty
 */
export const postFormRedirect = (
  {
    data = [],
    url,
    method = 'POST',
    authenticityToken = window.Silverfin.csrfToken(),
  }: PostFormRedirectParams = {} as PostFormRedirectParams
): void => {
  if (!authenticityToken) {
    throw new Error('SFetch: Dynamic form submit needs an authenticity token')
  }

  if (!url) {
    throw new Error('SFetch: Dynamic form submit needs a submit URL')
  }

  const form = document.createElement('form')
  form.method = method
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  form.action = typeof url === 'string' ? url : url.toString()

  form.appendChild(createHiddenInput('authenticity_token', authenticityToken))

  data.forEach((dataItem) => {
    const hiddenInput = createHiddenInput(dataItem.key, dataItem.value)
    form.appendChild(hiddenInput)
  })

  document.body.appendChild(form)
  form.submit()
}
